export default __webpack_public_path__ + "static/media/mars38.c4ad31da.gif";